import type { Certificate } from '@/types/Certificate';
import type { Rating } from '@/types/Rating';

export default interface FlightSchoolCourse {
    id: number;
    certificate: Certificate;
    ratings: Rating[];
}

export enum CourseTypeLabel {
    PILOT_CERTIFICATIONS = 'Pilot Certifications',
    CANADIAN_CONVERSION = 'Canadian Conversion',
}

/**
 * This is originally for FlightSchoolCourseSelection.vue.
 * It is used to split the courses into two arrays: one for canadian courses and one for non-canadian courses.
 */
export type CourseTypes = {
    label: CourseTypeLabel;
    courses: FlightSchoolCourse[];
    icon: string;
};
